import { Select } from "antd";
import React, { useEffect, useState } from "react";
import {
	BsArrowsMove,
	BsDownload,
	BsFolder2Open,
	BsInfoCircle,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import {
	download_file_content,
	get_generated_file_list,
	move_file_in_blob,
} from "../../../../api/endpoints/auditory";
import Main from "../../../layout/main/Main";
import { COLORS, Typo } from "../../../layout/theme";
import {
	AntdTable,
	Container,
	FilterContainer,
	ImageSection,
	Inner,
	Section,
	TableContainer,
} from "./styles";
import { get_distributors_name_list_checkpos } from "../../../../api/endpoints/distributors";
import { get_megaDistributors_name_list_checkpos } from "../../../../api/endpoints/megaDistributors";
import { CONSTANTS } from "../../../../utils/constants";
import {
	TYPE,
	openNotificationWithIcon,
} from "../../../../utils/notificationToast";
import moment from "moment";
import { get_clients_name_list_filtered } from "../../../../api/endpoints/clients";
import CustomAntdTooltip from "../../../common/custom-antd-tooltip/CustomAntdTooltip";

const { Option } = Select;

export default function SendedFiles() {
	const [isLoading, setIsLoading] = useState(false);
	const [distributors, setDistributors] = useState(null);
	const [selectedType, setSelectedType] = useState(null);
	const [selectedDistributor, setSelectedDistributor] = useState(null);
	const [generatedFileList, setGeneratedFileList] = useState(null);
	const [folderState, setFolderState] = useState("enviados");
	const [clients, setClients] = useState(null);
	const [selectedClient, setSelectedClient] = useState(null);
	const [distributorFolderInfo, setDistributorFolderInfo] = useState(null);
	const [generatedFileLogList, setGeneratedFileLogList] = useState(null);
	const [flag, setFlag] = useState(false);

	const folders = [
		{
			id: "enviados",
			name: "enviados",
		},
		{
			id: "pendientes",
			name: "pendientes",
		},
	];

	const fetch_distributors = async () => {
		const res = await get_distributors_name_list_checkpos();
		setDistributors(res);
	};

	const fetch_mega_distributors = async () => {
		const res = await get_megaDistributors_name_list_checkpos();
		setDistributors(res);
	};

	const fetch_client_list = async () => {
		const res = await get_clients_name_list_filtered();
		setClients(res.filter((c) => c.isApproved && c.isSeller));
	};

	const fetch_logs_list = async () => {
		setIsLoading(true);
		try {
			const folderPath = `${selectedType}/${selectedDistributor}/logs`;
			const folderState = "mobile";
			const res = await get_generated_file_list(folderPath, folderState);
			setGeneratedFileLogList(res?.generatedFileList);
		} catch (error) {
			setGeneratedFileLogList(null);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_generated_file_list = async () => {
		setIsLoading(true);
		try {
			const distributor = distributors.find(
				(d) => d.id === selectedDistributor,
			);
			let distributorSendType;
			let folderPath;
			if (selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS) {
				distributorSendType = JSON.parse(distributor.mobileTypeOfArchive).send;
				folderPath =
					distributorSendType === CONSTANTS.TYPE_OF_SEND[0]
						? `${selectedType}/${selectedDistributor}/${distributorSendType}/mobile/${selectedClient}`
						: `${selectedType}/${selectedDistributor}/${distributorSendType}/mobile`;
			} else {
				distributorSendType = JSON.parse(distributor.mobileTypeOfArchive).send;
				folderPath = `${selectedType}/${selectedDistributor}/${distributorSendType}/mobile`;
			}
			const res = await get_generated_file_list(folderPath, folderState);
			setGeneratedFileList(res.generatedFileList);
		} catch (error) {
			setGeneratedFileList(null);
			if (error?.response?.status === 404) {
				return openNotificationWithIcon(
					TYPE.ERROR,
					"Directorio vacío",
					"El criterio de búsqueda no posee archivos para mostrar",
				);
			} else {
				return openNotificationWithIcon(
					TYPE.ERROR,
					"Error de búsqueda",
					"Ha ocurrido un error al intentar realizar la búsqueda, por favor contacte con soporte a soporte@onetransfer.com",
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setDistributorFolderInfo(null);
		selectedType &&
			selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
			fetch_distributors();
		selectedType &&
			selectedType === CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS &&
			fetch_mega_distributors();
		selectedType &&
			selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
			fetch_client_list();
	}, [selectedType]);

	useEffect(() => {
		if (
			(selectedDistributor &&
				selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
				distributorFolderInfo === CONSTANTS.TYPE_OF_SEND[0] &&
				selectedClient) ||
			(selectedDistributor &&
				selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
				distributorFolderInfo !== CONSTANTS.TYPE_OF_SEND[0]) ||
			(selectedDistributor &&
				selectedType === CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS)
		) {
			fetch_generated_file_list();
			selectedDistributor && folderState === "pendientes" && fetch_logs_list();
		}
	}, [selectedDistributor, selectedClient, folderState, flag]);

	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					FECHA CREACION
				</div>
			),
			dataIndex: "created",
			key: "created",
			width: 200,
			render: (value, record, index) => {
				return (
					<Typo level={6} type="darkGrey">
						{moment(value).format("DD-MM-YYYY")}
					</Typo>
				);
			},
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					NOMBRE ARCHIVO
				</div>
			),
			dataIndex: "name",
			key: "name",
			render: (value, record, index) => {
				const parts = value.split("/");
				const fileName = parts[parts.length - 1];
				return (
					<Typo level={6} type="secondary" fontWeight="700">
						{fileName}
					</Typo>
				);
			},
		},
		folderState === "pendientes"
			? {
					title: () => (
						<div style={{ color: COLORS.White, fontWeight: 700 }}></div>
					),
					dataIndex: "download",
					key: "download",
					width: 150,
					align: "center",
					render: (text, record, index) => {
						const generatedDate = moment(record.created).format("YYYYMMDD");

						const errorLogs = generatedFileLogList?.filter((file) => {
							const fileNameParts = file.name.split("_");
							const logDate = fileNameParts[7];
							return (
								logDate.startsWith(generatedDate) &&
								file.name.includes("errors.log")
							);
						});

						const sortedErrorLogs =
							errorLogs?.sort((a, b) => {
								const dateA = moment(a.name.split("_")[3], "YYYYMMDD");
								const dateB = moment(b.name.split("_")[3], "YYYYMMDD");
								return dateB - dateA;
							}) || null;

						const latestErrorLog = sortedErrorLogs ? sortedErrorLogs[0] : null;

						return (
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									gap: 20,
								}}
							>
								<CustomAntdTooltip
									placement="top"
									width="180px"
									color={COLORS.Secondary}
									tooltipContent={[
										{
											title: "Descargar archivo",
										},
									]}
								>
									<div
										onClick={(e) => handleDownload(record.name)}
										style={{ cursor: "pointer" }}
									>
										<BsDownload color={COLORS.Secondary} />
									</div>
								</CustomAntdTooltip>
								{latestErrorLog && (
									<CustomAntdTooltip
										placement="top"
										width="180px"
										color={COLORS.Secondary}
										tooltipContent={[
											{
												title: "Descargar log",
											},
										]}
									>
										<div
											onClick={(e) => handleDownload(latestErrorLog.name)}
											style={{ cursor: "pointer" }}
										>
											<BsInfoCircle color={COLORS.Warning} />
										</div>
									</CustomAntdTooltip>
								)}
								<CustomAntdTooltip
									placement="top"
									width="180px"
									color={COLORS.Secondary}
									tooltipContent={[
										{
											title: "Mover a enviados",
										},
									]}
								>
									<div
										onClick={(e) => handleMove(record.name)}
										style={{
											cursor: "pointer",
										}}
									>
										<BsFolder2Open color={COLORS.Default} />
									</div>
								</CustomAntdTooltip>
							</div>
						);
					},
				}
			: {
					title: () => (
						<div style={{ color: COLORS.White, fontWeight: 700 }}></div>
					),
					dataIndex: "download",
					key: "download",
					width: 150,
					align: "center",
					render: (text, record, index) => (
						<div
							onClick={(e) => handleDownload(record.name)}
							style={{ cursor: "pointer" }}
						>
							<BsDownload color={COLORS.Secondary} />
						</div>
					),
				},
	];

	const handleMove = async (filePath) => {
		setIsLoading(true);
		try {
			const sourceFolder = "pendientes";
			const destinationFolder = "enviados";

			const res = await move_file_in_blob(
				filePath,
				sourceFolder,
				destinationFolder,
			);

			res && setFlag((prev) => !prev);

			res &&
				openNotificationWithIcon(
					TYPE.SUCCESS,
					"Archivo movido",
					`El archivo ha sido movido a 'enviados' correctamente.`,
				);
		} catch (error) {
			console.error("Error al mover el archivo", error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Error de movimiento",
				"No se pudo mover el archivo. Intenta de nuevo.",
			);
		} finally {
			setIsLoading(false);
		}
	};

	const handleDownload = async (filePath) => {
		setIsLoading(true);
		try {
			const parts = filePath.split("/");
			const fileName = parts[parts.length - 1];
			const res = await download_file_content(filePath);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Archivos generados
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<Inner>
					<Section>
						<FilterContainer>
							<Typo type="darkGrey" fontWeight={700} fontSize={30}>
								Archivos Generados
							</Typo>
							<div style={{ display: "flex", gap: 10 }}>
								<Select
									style={{ width: "200px" }}
									onChange={(e) => {
										setSelectedType(e);
										setSelectedDistributor(null);
										setGeneratedFileList(null);
									}}
									value={selectedType}
									placeholder="Elegir tipo"
								>
									<Option key={1} value={CONSTANTS.FILE_FOLDER_DISTRIBUTORS}>
										Droguería
									</Option>
									<Option
										key={2}
										value={CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS}
									>
										Distribuidor
									</Option>
								</Select>
								{distributors && selectedType && (
									<Select
										style={{ width: "250px" }}
										onChange={(e) => {
											const distributor = distributors.find((d) => d.id === e);
											const sendType = JSON.parse(
												distributor.mobileTypeOfArchive,
											).send;
											setDistributorFolderInfo(sendType);
											setSelectedDistributor(e);
											setSelectedClient(null);
										}}
										placeholder={
											selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS
												? "Elegir droguería"
												: "Elegir distribuidor"
										}
										value={selectedDistributor}
									>
										{distributors?.map((i, idx) => (
											<Option key={`distributor_${idx}`} value={i.id}>
												{i.name}
											</Option>
										))}
									</Select>
								)}
								<Section>
									{distributors &&
										selectedType &&
										selectedDistributor &&
										selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
										distributorFolderInfo === CONSTANTS.TYPE_OF_SEND[0] && (
											<Select
												style={{ width: "200px" }}
												onChange={(e) => {
													setSelectedClient(e);
												}}
												placeholder={"Elegir cliente"}
												value={selectedClient}
											>
												{clients?.map((i, idx) => (
													<Option key={`client_${idx}`} value={i.id}>
														{i.name}
													</Option>
												))}
											</Select>
										)}
									{((selectedDistributor &&
										selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
										distributorFolderInfo === CONSTANTS.TYPE_OF_SEND[0] &&
										selectedClient) ||
										(selectedDistributor &&
											selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
											distributorFolderInfo !== CONSTANTS.TYPE_OF_SEND[0]) ||
										(selectedDistributor &&
											selectedType ===
												CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS)) && (
										<Typo>Tipo de envío: {distributorFolderInfo}</Typo>
									)}
								</Section>
								{selectedDistributor &&
									selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
									distributorFolderInfo === CONSTANTS.TYPE_OF_SEND[3] && (
										<Select
											style={{ width: "200px" }}
											onChange={(e) => {
												setFolderState(e);
											}}
											placeholder={"Elegir carpeta"}
											value={folderState}
										>
											{folders?.map((i, idx) => (
												<Option key={`folder_${idx}`} value={i.id}>
													{i.name}
												</Option>
											))}
										</Select>
									)}
							</div>
						</FilterContainer>
						{((selectedDistributor &&
							selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
							distributorFolderInfo === CONSTANTS.TYPE_OF_SEND[0] &&
							selectedClient) ||
							(selectedDistributor &&
								selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
								distributorFolderInfo !== CONSTANTS.TYPE_OF_SEND[0]) ||
							(selectedDistributor &&
								selectedType === CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS)) && (
							<TableContainer>
								<AntdTable
									columns={columns}
									loading={isLoading}
									dataSource={generatedFileList}
									pagination={false}
									scroll={{
										y: 500,
									}}
								/>
							</TableContainer>
						)}
					</Section>
				</Inner>
			</Main.Body>
		</Main>
	);
}
